import { apiResponseErrorHandler } from 'helpers/common.helper';
import axios from 'axios';

export default {
	

	generateProfitLossStatementSummaryReport(data) {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/reports/profit-loss-statement-summary`, data, {
					headers: {
						Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
							}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	
	
	generateProfitLossSummaryReport(data) {
		return this.handelAlert((res, rej, loadObj) => {
			axios
			.post(`${base}/api/reports/generate-profit-loss-statement-summary`, data, {
				headers: {
					Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
					}`
				},
				// responseType: 'blob'
			})
			.then((response) => {
				res(response.data);
			})
			.catch((rej) => {
				apiResponseErrorHandler(rej);
				res(rej.response.data);
			});
		}, false);
	},
	
	async generateProfitLossSalesStatementReport(data) {
		
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/reports/profit-loss-statement/sales`, data, {
					headers: {
						Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
							}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	
	downloadProfitLossSalesStatementSummaryReport(data) {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/reports/profit-loss-statement/sales/download`, data, {
					headers: {
						Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
							}`
					},
					// responseType: 'blob'
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},


	async generateProfitLossPurchaseOrdersStatementReport(data) {
		
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/reports/profit-loss-statement/purchase-orders`, data, {
					headers: {
						Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
							}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	
	downloadProfitLossPurchaseOrdersStatementReport(data) {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/reports/profit-loss-statement/purchase-orders/download`, data, {
					headers: {
						Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
							}`
					},
					// responseType: 'blob'
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},


	async generateProfitLossShippingCostsStatementReport(data) {
		
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/reports/profit-loss-statement/shipping-costs`, data, {
					headers: {
						Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
							}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	
	downloadProfitLossShippingCostsStatementReport(data) {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/reports/profit-loss-statement/shipping-costs/download`, data, {
					headers: {
						Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
							}`
					},
					// responseType: 'blob'
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},



	generateContactRevenueSummaryReport(data) {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/reports/contact-revenue-summary`, data, {
					headers: {
						Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
							}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	
	async generateContactRevenueDetailsReport(data) {
		
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/reports/contact-revenue-details`, data, {
					headers: {
						Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
							}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	
	downloadContactRevenueDetailsReport(data) {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/reports/contact-revenue-details/download`, data, {
					headers: {
						Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
							}`
					},
					// responseType: 'blob'
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},




	generateContactExpenseSummaryReport(data) {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/reports/contact-expense-summary`, data, {
					headers: {
						Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
							}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	
	async generateContactExpenseDetailsReport(data) {
		
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/reports/contact-expense-details`, data, {
					headers: {
						Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
							}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	
	downloadContactExpenseDetailsReport(data) {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/reports/contact-expense-details/download`, data, {
					headers: {
						Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
							}`
					},
					// responseType: 'blob'
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
    
	getAllReports() {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.get(`${base}/api/reports/get-allreports`, {
					headers: {
						Authorization: `Bearer ${
							JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
						}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej)
					res(rej.response.data);
				});
		}, false);
	},



};